import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { Player, ControlBar } from "video-react";

import "./../../../node_modules/video-react/dist/video-react.css";
import { Link } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: "800px", // Set your width here
    },
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const ButtonComponent = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  let navigate = useNavigate();

  const [input, setInput] = useState();
  // const route = useRoutes();

  const onSubmit = () => {
    if (!input || input == "") {
      return;
    }
    // navigate('/');
    navigate(`/track/${input}`);
  };

  return (
    <>
      <div className=" flex justify-center mx-[auto] w-[17rem] sm-[20rem] sm:border-2">
        <div
          className="md:hidden lg:mt-[-5rem] md:mt-[-3rem] mx-[auto] sm:mt-[1rem] mt-[1rem] text-center md:text-left absolute"
          style={{ zIndex: 9 }}
        >
          <h2 className="banner-heading react-reveal text-[red] text-2xl sm:text-2xl font-semibold">
            Track Your Shipment
          </h2>
          <div className="banner-input react-reveal text-sm flex flex-row my-[.5rem]">
            <input
              type="number"
              onChange={(e) => {
                setInput(e.target.value);
              }}
              placeholder="Tracking Number"
              className="p-2 md:w-[30rem] sm:w-[18rem] focus:outline-none opacity-75 rounded-l-sm"
            />
            <button
              onClick={onSubmit}
              type="button"
              className="bg-[#D40511] text-white p-3 w-full md:w-[10rem] sm:w-[8rem] rounded-r-sm transition-all duration-500 gradientbg"
            >
              Track Shipment
            </button>
          </div>
        </div>
      </div>

      <div className="button-component sm:flex grid flex-col md:flex-row px-[2rem] lg:mx-[3rem] md:ml-[0rem] mx-[1rem] mt-[8rem] sm:relative justify-center items-center lg:mt-[-3rem] md:mt-[-2rem] z-10">
        <div className="flex">
          <Link
            to="/tcs-kardo"
            className="hover:z-50 lg:w-[208px] md:w-[170px] sm:w-[49.5%] w-[49.5%] "
          >
            <div className="react-reveal">
              <div className="card rounded-t-md md:rounded-none md:rounded-l-md w-[24%] w-[12rem]">
                <img
                  src="/Home/KeyFeatures/tcskardo.svg"
                  alt="TCS Kardo"
                  className="h-[2.3rem]"
                />
                <div className="text-sm">TCS Kardo</div>
              </div>
            </div>
          </Link>
          <Link
            to="/schedulePickUp"
            className="hover:z-50 lg:w-[208px] md:w-[170px]  sm:w-[49.5%] w-[49.5%]"
          >
            <div className="react-reveal">
              <div className="card pb-[.5rem]  w-[24%] w-[12rem] lg:rounded-none rounded-tr-md">
                <img
                  src="/Home/KeyFeatures/pickup-icon-5.svg"
                  alt="TCS Kardo"
                  className="h-[2.3rem]"
                />
                <div className="text-sm">Schedule A Pickup</div>
              </div>
            </div>
          </Link>
        </div>

        <div className="flex">
          <Link
            to="/ratecalculator"
            className="hover:z-50 lg:w-[208px] md:w-[170px] sm:w-[49.5%] w-[49.5%] "
          >
            <div className="react-reveal">
              <div className="card undefined min-w-[12rem] lg:rounded-none rounded-b-md">
                <img
                  src="/Home/KeyFeatures/calculater.svg"
                  alt="Rate Calculator"
                  className="h-[1.8rem] "
                />
                <div className="text-sm">Rate Calculator</div>
              </div>
            </div>
          </Link>
          <Link
            to="/tcs-nearyou"
            className="hover:z-50 lg:w-[208px]  md:w-[170px] sm:w-[49.5%] w-[47.5%]"
          >
            <div className="react-reveal">
              <div className="card undefined  md:rounded-r-md sm:w-[10rem] md:w-[8rem] lg:w-[10rem] rounded-br-md">
                <img
                  src="/Home/KeyFeatures/tcsnearyou.svg"
                  alt="TCS Near You"
                  className="h-[2rem]"
                />
                <div className="text-sm">TCS Location Map</div>
              </div>
            </div>
          </Link>
        </div>
        {/* <a className="hover:z-50 md:w-[27.5%] lg:w-[208px]" onClick={(()=>{handleClickOpen()})}>
          <div className="react-reveal">
            <div className="card rounded-b-md md:rounded-none md:rounded-r-md">
              <img src="/update-icons/promotion.svg" alt="TCS for Bussiness" className="h-[2rem]" />
              <div className="text-sm">Promotions</div>
            </div>
          </div>
        </a> */}
      </div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="video-modal"
        open={open}
      >
        <DialogContent dividers>
          <Player autoPlay={true}>
            <source src="./video/promotion_video.mp4" />
            <ControlBar autoHide={false} />
          </Player>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default ButtonComponent;
